// extracted by mini-css-extract-plugin
module.exports = {"news-card__subtitle":"news-card_news-card__subtitle__jV_5n"};